import { useEffect, useState } from "react";
import { Button, Col, PageHeader } from "antd";
import { Link, useHistory } from "react-router-dom";
import LayoutCss from "layout/layout.module.scss";
import CommissionPlan from "redux/models/commissionPlan";
import K from "utilities/constants";
import { selectUser } from "redux/slices/userSlice";
import { useSelector } from "react-redux";
import { Columns } from "./columns";
import { DataTableLayout } from "../../../common/components/dataTableLayout/dataTableLayout";
import { ClientSideDataGrid } from "../../../common/components/clientSideDataGrid/clientSideDataGrid";
import { usePageFilter } from "../../../hooks/usePageFilters";

export default function CommissionPlans() {
  const history = useHistory();

  const userSlice = useSelector(selectUser);
  const userId = userSlice.details.id;

  const [search, setSearch] = usePageFilter("commission_plans_search");

  const [commissionPlans, setCommissionPlans] = useState();

  const fetchCommissionPlans = async () => {
    try {
      const res = await CommissionPlan.getAll();
      setCommissionPlans(res);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCommissionPlans();
  }, []);

  const rowClickedHandler = (event) => {
    history.push(
      `/configurations/commission-plans/detail/${event.data.commissionId}`,
    );
  };

  return (
    <>
      <PageHeader
        ghost={false}
        title="Commission Plans"
        className={`${LayoutCss.appPageHeader} ${LayoutCss.pageHeader}`}
      />

      <DataTableLayout
        searchDefaultValue={search}
        onSearchChange={setSearch}
        actions={[
          {
            permissions: [K.Permissions.CreateCommissionPlan],
            renderer: () => (
              <Col>
                <Link to="/configurations/commission-plans/create">
                  <Button type="primary" className={LayoutCss.appHeaderBtn}>
                    Create
                  </Button>
                </Link>
              </Col>
            ),
          },
        ]}
      >
        <ClientSideDataGrid
          userId={userId}
          configKey={K.AgGridTable.Keys.CommissionPlansVisibleColumn}
          defaultColumnConfig={Columns}
          rowData={commissionPlans}
          quickFilterText={search}
          onRowClicked={rowClickedHandler}
        />
      </DataTableLayout>
    </>
  );
}
